import moment from 'moment'

// test: jest src/utils/booking/__tests__/BookingWindow.test.js
export default class BookingWindow {
  constructor() {
    this.windowByDays = null
    this.windowByMinutes = null
  }

  setWindowByDays(days) {
    this.windowByDays = days
  }

  setWindowByMinutes(minutes) {
    this.windowByMinutes = minutes
  }

  isAvailable(targetTime, currentTime) {
    const target = moment(targetTime)
    const current = moment(currentTime)

    const windowByDays = this.windowByDays || 0
    const windowByMinutes = this.windowByMinutes || 0

    if (windowByDays > 0) {
      const diffInDays = target.clone().startOf('day').diff(current.clone().startOf('day'), 'days')
      return diffInDays <= windowByDays - 1
    }

    if (windowByMinutes > 0) {
      const diffInMinutes = target.clone().startOf('minute').diff(current.clone().startOf('minute'), 'minutes')
      return diffInMinutes <= windowByMinutes - 1
    }

    return false
  }
}
